import styled from 'styled-components';

const GameLabel = styled.div`
    position: absolute;
    top: 0.6rem;
    left: 1px;
    background: rgba(0, 0, 0, 0.85);
    color: rgba(220, 220, 220, 1);
    padding: 0.4rem 0.6rem;
    font-size: 0.7rem;
    line-height: 1;
    font-weight: 500;
    border-radius: 0 4px 4px 0;
    text-transform: uppercase;
    font-family: 'Space Grotesk', sans-serif;
    box-shadow: 4px 4px 21px 0 rgba(0, 0, 0, 0.4);

    body.dark & {
        background: rgba(220, 220, 220, 1);
        color: rgba(0, 0, 0, 0.85);
    }

    @media (min-width: 1024px) {
        font-size: 0.86rem;
    }
`;

export default GameLabel;
